var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackDrawerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 16.5,
    fill: "white",
    stroke: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7068 9.29279C20.8943 9.48031 20.9996 9.73462 20.9996 9.99979C20.9996 10.265 20.8943 10.5193 20.7068 10.7068L14.4138 16.9998L20.7068 23.2928C20.8889 23.4814 20.9897 23.734 20.9875 23.9962C20.9852 24.2584 20.88 24.5092 20.6946 24.6946C20.5092 24.88 20.2584 24.9852 19.9962 24.9875C19.734 24.9897 19.4814 24.8889 19.2928 24.7068L12.2928 17.7068C12.1053 17.5193 12 17.265 12 16.9998C12 16.7346 12.1053 16.4803 12.2928 16.2928L19.2928 9.29279C19.4803 9.10532 19.7346 9 19.9998 9C20.265 9 20.5193 9.10532 20.7068 9.29279Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackDrawerIcon);
export default __webpack_public_path__ + "static/media/back-drawer-icon.ff0e10bb73ef207525a3387ac3f7188d.svg";
export { ForwardRef as ReactComponent };